import { render, staticRenderFns } from "./InfoStandingsTournament.vue?vue&type=template&id=0271b800"
import script from "./InfoStandingsTournament.vue?vue&type=script&lang=js"
export * from "./InfoStandingsTournament.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports